// src/pages/AdminReporteHoras.js
import React from 'react';
import { useReporteHoras } from '../hooks/useReporteHoras';

export default function AdminReporteHoras() {
    const { mesSeleccionado, setMesSeleccionado, estadisticas, loading } = useReporteHoras();

    return (
        <div className="min-h-screen p-4 md:p-8 bg-slate-50/50 animate-fade-in">
            {/* CABECERA Y FILTRO MENSUAL */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8">
                <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center w-12 h-12 bg-indigo-600 text-white rounded-2xl shadow-md shadow-indigo-600/20">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path></svg>
                    </div>
                    <div>
                        <h1 className="text-3xl font-black text-slate-900 tracking-tight">Reporte Mensual</h1>
                        <p className="text-sm font-semibold text-slate-500 mt-1">Cálculo de horas computadas para nóminas</p>
                    </div>
                </div>

                <div className="w-full md:w-64">
                    <label htmlFor="filtro-mes" className="block mb-1.5 text-[11px] font-black tracking-widest text-slate-500 uppercase">
                        Periodo de Facturación
                    </label>
                    <input
                        id="filtro-mes"
                        type="month"
                        value={mesSeleccionado}
                        onChange={(e) => setMesSeleccionado(e.target.value)}
                        className="w-full py-3.5 px-4 bg-white border border-slate-200/80 rounded-2xl focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 transition-all text-sm font-bold text-slate-700 shadow-sm cursor-pointer"
                    />
                </div>
            </div>

            {/* TABLA DE RESULTADOS */}
            <div className="bg-white border border-slate-200/80 rounded-[2rem] shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse min-w-[600px]">
                        <thead>
                        <tr className="bg-slate-50/50 border-b border-slate-100">
                            <th className="px-6 py-5 text-[11px] font-black tracking-widest text-slate-400 uppercase">Profesional</th>
                            <th className="px-6 py-5 text-[11px] font-black tracking-widest text-slate-400 uppercase text-center">Días Activos</th>
                            <th className="px-6 py-5 text-[11px] font-black tracking-widest text-slate-400 uppercase text-right">Horas Computadas</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100/80">
                        {loading ? (
                            [...Array(4)].map((_, i) => (
                                <tr key={i} className="animate-pulse bg-white">
                                    <td className="px-6 py-4 flex items-center gap-3"><div className="w-10 h-10 bg-slate-100 rounded-2xl"></div><div className="h-4 bg-slate-100 rounded-md w-32"></div></td>
                                    <td className="px-6 py-4"><div className="h-4 bg-slate-100 rounded-md w-12 mx-auto"></div></td>
                                    <td className="px-6 py-4"><div className="h-8 bg-slate-100 rounded-lg w-28 ml-auto"></div></td>
                                </tr>
                            ))
                        ) : estadisticas.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="px-6 py-20 text-center">
                                    <h3 className="text-slate-700 font-black text-lg">Sin datos para este mes</h3>
                                </td>
                            </tr>
                        ) : (
                            estadisticas.map((stat, index) => (
                                <tr key={stat.id || stat._id || index} className="hover:bg-slate-50/80 transition-colors group">
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-3">
                                            <div className="flex items-center justify-center w-10 h-10 font-black text-slate-700 bg-slate-100 border border-slate-200 rounded-2xl group-hover:scale-105 transition-transform">
                                                {stat.usuario?.nombre?.[0] || 'U'}
                                            </div>
                                            <span className="font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
                                                    {stat.usuario?.nombre} {stat.usuario?.apellidos}
                                                </span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-center">
                                        <span className="font-black text-slate-700 bg-slate-100 px-3 py-1 rounded-lg border border-slate-200/60">{stat.diasTrabajados || 0}</span>
                                    </td>
                                    <td className="px-6 py-4 text-right">
                                            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-black text-indigo-700 bg-indigo-50 border border-indigo-100 shadow-sm">
                                                {stat.totalHorasFormat || '0:00 h'}
                                            </span>
                                    </td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}